var map = {
	"./en/baoming.png": "cRxH",
	"./es/baoming.png": "vAw0",
	"./pt/baoming.png": "sS5f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K3WY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/baoming\.png$
// module id = K3WY
// module chunks = 0